<template>
  <div class="product">
    <div
      class="product-banner"
      v-if="showProductImg"
      :style="{ backgroundImage: 'url(' + showProductImg + ')' }"
    >
      <div class="product-banner__done" v-if="currentBankHasBinding">
        <div class="product-banner__done__tip">
          数币红包已发放至<span class="highlight-tip"
            >【数币App-服务-红包】</span
          >
          <br />
          美团券包已发放至<span class="highlight-tip"
            >【美团-数字人⺠币专区-现金券】</span
          >
        </div>
      </div>
      <div class="product-banner__tip">
        - 领取后可与其他红包<span class="product-banner__tip__bold"
          >叠加使用</span
        >
        -
      </div>
    </div>
    <Introduction
      :hasOpenThatBank="hasOpenThatBank"
      :bankName="bankName"
      :bankType="bankType"
      :currentBankHasBinding="currentBankHasBinding"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
    <bottom-button
      v-if="hasOpenThatBank && !currentBankHasBinding"
      :mobileMask="mobileMask"
      :bankName="bankName"
      :bankType="bankType"
      :hasOpenThatBank="hasOpenThatBank"
      :couponPackage="couponPackage"
      :applyPageType="applyPageType"
      :pageABStrategy="pageABStrategy"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
    <div class="product-bottom" v-if="!hasOpenThatBank">
      <div class="product-bottom__button" @click="openDownloadDcepModal">
        立即领礼包
      </div>
    </div>
    <half-page-download
      :visible.sync="showDownloadModal"
      :downloadTile="downloadTile"
      :bankName="bankName"
      :bankType="bankType"
      :mobileMask="mobileMask"
      :pushSubWalletABStrategy="pushSubWalletABStrategy"
    />
  </div>
</template>
<script>
import Introduction from './components/Introduction.vue';
import BottomButton from './components/BottomButton.vue';
import HalfPageDownload from './components/HalfPageDownload.vue';
import { lxConfig } from '@/analytic/guideConfig';
import { lx } from '@/analytic/index';
import { env } from '@/common/env';
import { monitor } from '@/common/monitor';
export default {
  components: {
    Introduction,
    BottomButton,
    HalfPageDownload
  },
  props: {
    currentBankHasBinding: {
      type: Boolean,
      default: false
    },
    hasOpenThatBank: {
      type: Boolean,
      default: false
    },
    mobileMask: {
      type: String,
      default: ""
    },
    bankType: {
      type: String,
      default: ''
    },
    bankName: {
      type: String,
      default: ''
    },
    couponPackage: {
      type: Object,
      default: () => {}
    },
    applyPageType: {
      type: String,
      default: ''
    },
    pageABStrategy: {
      type: String,
      default: ''
    },
    pushSubWalletABStrategy: {
      type: String,
      default: ''
    },
  },
  computed: {
    userStatus() {
      if (this.currentBankHasBinding) {
        return '已推子';
      }
      if (this.hasOpenThatBank) {
        return '开通未推子';
      }
      if (!this.hasOpenThatBank) {
        return '报名未开通';
      }
    }
  },
  data() {
    return {
      showDownloadModal: false,
      downloadTile: '仅差2步，30元礼包到账',
      showProductImg:
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/show-product-image-20220418-new-1.png'
    };
  },
  created() {
    monitor.captureMessage(
      {
        name: '【攻略页-商品版本】',
        msg: ''
      },
      {
        level: 'info'
      }
    );
    // 底部按钮埋点
    if (!this.hasOpenThatBank) {
      lx.mv(
        lxConfig.mv_bottom_download,
        {
          from: env.from,
          abtest: this.pageABStrategy,
          page_type: this.applyPageType,
          user_status: this.userStatus || -999
        },
        {
          cid: lxConfig.pv
        }
      );
    }
  },
  methods: {
    openDownloadDcepModal() {
      lx.mc(
        lxConfig.mc_bottom_download,
        {
          from: env.from,
          abtest: this.pageABStrategy,
          page_type: this.applyPageType,
          user_status: this.userStatus || -999
        },
        {
          cid: lxConfig.pv
        }
      );
      this.showDownloadModal = true;
    }
  }
};
</script>
<style scoped lang="less">
@import '../../../styles/fn.less';
.product {
  padding-bottom: 3.8rem;
  &-banner {
    width: 6.9rem;
    height: 7.82rem;
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin: 0 auto 0.2rem;
    text-align: center;
    position: relative;
    &__done {
      padding-top: 2rem;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 2rem;
      width: 6.32rem;
      height: 1.34rem;
      text-align: center;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/has-bind-wallet-info-20220411.png'
      );
      &__tip {
        position: absolute;
        top: 0.49rem;
        left: 0;
        right: 0;
        font-family: PingFangSC-Medium;
        font-size: 0.22rem;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 0.3rem;
        font-weight: 500;
      }
      .highlight-tip {
        color: #ffd524;
      }
    }
    &__tip {
      font-family: PingFangSC-Regular;
      font-size: 0.22rem;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 0.3rem;
      font-weight: 400;
      padding-top: 3.28rem;
      &__bold {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
      }
    }
  }
  &-bottom {
    position: fixed;
    background: #ffffff;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    border-radius: 0.3rem 0.3rem 0 0;
    &__button {
      margin: 0.47rem 0 0.52rem 0;
      width: 5.82rem;
      height: 1.06rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.34rem;
      color: #4c1111;
      text-align: center;
      font-weight: 600;
      line-height: 0.48rem;
      padding-top: 0.3rem;
      .bg-image-auto(
        'https://s3plus.meituan.net/static-prod01/com.sankuai.fspfepayresource.dcep.activity-files/guide-bottom-btn-20220726.png'
      );
    }
  }
}
</style>
